// extracted by mini-css-extract-plugin
export default {"box":"sUxzTloTaKmpsWwJLbGP","title":"wYgKC95aaVm0nZQ_E2Fk","buttonGroup":"sAb6ux8WaDC_Jnm4ojxl"};